import React from 'react';

const FooterSection = () => {
  const currentYear = new Date()?.getFullYear();

  return (
    <div className="flex flex-col justify-center items-center min-h-[80px] m-0 p-0 rounded-t-[32px]" style={{ background: 'linear-gradient(135deg, #e8ecf1 0%, #dce1e8 100%)', overflow: 'hidden' }}>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 m-0 p-0">
          <div className="flex flex-col md:flex-row items-center justify-center m-0 p-0 md:space-x-2 space-y-2 md:space-y-0">
          <div className="text-sm text-gray-600">© 2025 logl Inc. All Rights Reserved.</div>
          </div>
        </div>
    </div>
  );
};

export default FooterSection;